import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './styles.css';
import './tasks/tasks.css';   // straight after styles.css: the Tasks block used to end that file
import './reply.css';        // the triage reply flow (B1552 to B1562); after styles.css, as the rest are

// The mount also contains onboarding, sign-in and the guest route outside Shell.
const root = document.getElementById('root')!;
root.classList.add('mc');
createRoot(root).render(<StrictMode><App /></StrictMode>);
